import { RegulatoryOrderingKey } from "../../../Regulatory.types";

export const EMPTY_SHELL_VALUE = "-";

export type Ordering = "none" | "asc" | "desc";

export const ORDERING_TABLE = {
  asc: "desc",
  desc: "none",
  none: "asc",
} as const;

export interface TableHeaderList {
  title: string;
  orderingTitle: RegulatoryOrderingKey;
  ordering: Ordering;
}
export const TABLE_HEADER_LIST: TableHeaderList[] = [
  { title: "ID", orderingTitle: "id", ordering: "none" },
  { title: "Label ID", orderingTitle: "labelId", ordering: "none" },
  {
    title: "Regulatory\nAgency",
    orderingTitle: "regulatoryAgency",
    ordering: "none",
  },
  { title: "Label Date", orderingTitle: "labelDate", ordering: "none" },
  { title: "Company", orderingTitle: "company", ordering: "none" },
  { title: "Unsuitable", orderingTitle: "unsuitable", ordering: "none" },
  { title: "Label Name", orderingTitle: "labelName", ordering: "none" },
  {
    title: "Classification",
    orderingTitle: "classification",
    ordering: "none",
  },
  { title: "Status", orderingTitle: "status", ordering: "none" },
  { title: "Start Date", orderingTitle: "startDate", ordering: "none" },
  { title: "Complete\nDate", orderingTitle: "completeDate", ordering: "none" },
  { title: "MC\nEditor", orderingTitle: "mcEditorName", ordering: "none" },
  { title: "FT\nEditor", orderingTitle: "ftEditorName", ordering: "none" },
];
